export default process.env.NODE_ENV === "production"
	? "wss://api.o4biz.ru/socket/"
	: "ws://localhost:3000";